import constants from '../services/constants';
import { atom } from 'recoil';

const updatedTeamRoleAtom = atom<{roleId:string, role:string, oldRoleName:string} | null>({
    key: constants.updatedTeamRoleAtom,
    default: null,
});

export default updatedTeamRoleAtom;